/**
 * ==========================================================================
 * JHC Also Like
 * Asset: assets/jhc-also-like.js
 * ==========================================================================
 */

(() => {
  'use strict';

  class JHCAlsoLike {
    constructor(section) {
      this.section = section;

      if (!this.section) return;

      this.init();
    }

    init() {
      // Reserved for future enhancements:
      // - Quick Add
      // - Wishlist
      // - Product badges
      // - Scroll animations
      // - Product swatches
    }
  }

  const initSections = () => {
    document
      .querySelectorAll('.jhc-also-like')
      .forEach((section) => {
        new JHCAlsoLike(section);
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSections);
  } else {
    initSections();
  }
})();